<button pButton pRipple class="text-center p-button-text mr-3"
        [loading]="isLoading"
        pTooltip="Notifiche" tooltipPosition="bottom"
        (click)="notificationsPanel.toggle($event)">
    <i
        class="fa fa-bell" pButtonIcon pBadge severity="danger" [value]="unreadNotifications.length.toString()"></i>
</button>
<app-popover #notificationsPanel
           class="notifications-list"
>
    <div class="notifications-list-container">
        <app-notifications-list
            [notifications]="unreadNotifications"
            (readAll)="loadNotifications()"
        ></app-notifications-list>
    </div>
</app-popover>
